import React, { useMemo, useRef } from 'react';
import Table from '../../table/agGrid/Table';
import { availableOfficesTooltips } from '../../../../agent-production/constants/agentProductionConstants';
import { searchTerms, status } from '../../../../constants';
import { availableOfficesColumns, getColumnsWithFilters } from '../../table/tableViews/availableOffices';
import addedOfficesColumns from '../../table/tableViews/addedOffices';

const AvailableOfficeTable = props => {
    const { availableOffices, hasAvailableOffices, hasColumnFilters, setDisplayedOffices, setCheckedAvailableOffices, gridRef } = props;

    const tableViewSettings = useMemo(() => {
        return hasColumnFilters ? getColumnsWithFilters() : availableOfficesColumns.availableOffices;
    }, []);

    const rowData = useMemo(() =>
        availableOffices?.map((office, i) => ({ ...office, id: `${i}-${office.officeId}` })) || [],
        [availableOffices]
    );

    const updateDisplayedOffices = e => {
        const visibleRows = [];
        const gridApi = e.api;
        gridApi.forEachNodeAfterFilterAndSort((node) => {
            visibleRows.push(node.data);
        });
        setDisplayedOffices(visibleRows);
    };

    const handleSelectionChanged = (event) => {
        const selectedNodes = event.api.getSelectedNodes();
        const selectedOffices = selectedNodes.map(node => node.data);
        setCheckedAvailableOffices(selectedOffices);
    };

    return <>
        {hasAvailableOffices
            ? <div className="m-2">
                <Table
                    gridRef={gridRef}
                    tableView={tableViewSettings}
                    rowData={rowData}
                    tableTitleWithTooltips={availableOfficesTooltips}
                    suppressNoRowsOverlay={true}
                    updateDisplayedOffices={setDisplayedOffices ? updateDisplayedOffices : null}
                    suppressRowClickSelection={false}
                    onSelectionChanged={handleSelectionChanged}
                    rowSelection={'multiple'}
                    rowMultiSelectWithClick={true}
                />

            </div>
            : <div className="h-75 w-100 d-flex flex-column justify-content-center align-items-center">
                <div className="font-weight-bold d-block">{searchTerms.noneAdded}</div>
                <p className="text-muted">{searchTerms.noOfficesAvailable}</p>
            </div>
        }
    </>;
};

const AddedOfficeTable = props => {
    const { addedOffices, setCheckedAddedOffices, gridRef } = props;

    const handleSelectionChanged = (event) => {
        const selectedNodes = event.api.getSelectedNodes();
        const selectedOffices = selectedNodes.map(node => node.data);
        setCheckedAddedOffices(selectedOffices);
    };

    const revisedAddedOffices = addedOffices.map((office) => {
        if (office.officeStatus === status.INACTIVE) {
            return ({
                ...office,
                officeName: searchTerms.inactiveOffice,
                statusKeyfield: 'officeStatus'
            });
        }
        return office;
    });

    const rowData = useMemo(() =>
        revisedAddedOffices?.map((office, i) => ({ ...office, id: `${i}-${office.officeId}` })) || [],
        [addedOffices]);

    return <Table
        gridRef={gridRef}
        tableView={addedOfficesColumns.addedOffices}
        rowData={rowData}
        tableTitleWithTooltips={availableOfficesTooltips}
        suppressNoRowsOverlay={true}
        suppressRowClickSelection={false}
        rowSelection={'multiple'}
        onSelectionChanged={handleSelectionChanged}
        rowMultiSelectWithClick={true}
    />;
};

export {
    AvailableOfficeTable,
    AddedOfficeTable
};
